import { Route } from '@angular/router';
import { initialDataResolver } from 'app/app.resolvers';
import { AdminPermissionGuard } from 'app/core/guards/admin-permission.guard';
import { AuthGuard } from 'app/core/guards/auth.guard';
import { LandingErrorRedirectGuard } from 'app/core/guards/landing-error-redirect.guard';
import { NoAuthGuard } from 'app/core/guards/no-auth.guard';
import { PendingChangesGuard } from 'app/core/guards/pending-changes.guard';
import { LayoutComponent } from 'app/layout/layout.component';

export const appRoutes: Route[] = [
  // The portal always lands on its own launcher, not on a permitted admin route
  { path: '', pathMatch: 'full', redirectTo: 'home' },
  { path: 'signed-in-redirect', pathMatch: 'full', redirectTo: 'home' },

  // Auth routes for guests
  {
    path: '',
    canActivate: [NoAuthGuard],
    canActivateChild: [NoAuthGuard],
    component: LayoutComponent,
    data: {
      layout: 'empty'
    },
    children: [
      {
        path: 'sign-in',
        loadComponent: () => import('app/modules/auth/sign-in/sign-in.component').then(m => m.SignInComponent)
      },
      {
        path: 'sign-in-admin',
        loadComponent: () => import('app/modules/auth/sign-in-admin/sign-in-admin.component').then(m => m.SignInAdminComponent)
      }
    ]
  },

  // Portal launcher: signed in, but outside the admin shell and its navigation
  {
    path: '',
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    component: LayoutComponent,
    data: {
      layout: 'empty'
    },
    children: [
      {
        path: 'home',
        loadComponent: () => import('app/modules/home/home.component').then(m => m.HomeComponent)
      }
    ]
  },

  // Landing routes
  {
    path: '',
    component: LayoutComponent,
    data: {
      layout: 'empty'
    },
    children: [
      {
        path: 'maintenance',
        loadComponent: () => import('app/modules/maintenance/maintenance.component').then(m => m.MaintenanceComponent)
      },

      {
        path: 'error',
        children: [
          {
            path: '404',
            canActivate: [
              LandingErrorRedirectGuard
            ],
            loadComponent: () => import('app/modules/error/error-404/error-404.component').then(m => m.Error404Component)
          },
          {
            path: '500',
            loadComponent: () => import('app/modules/error/error-500/error-500.component').then(m => m.Error500Component)
          }
        ]
      }
    ]
  },

  // Admin routes
  {
    path: '',
    canActivate: [AuthGuard],
    canActivateChild: [
      AuthGuard,
      AdminPermissionGuard
    ],
    component: LayoutComponent,
    resolve: {
      initialData: initialDataResolver
    },
    children: [
      {
        path: 'um',
        children: [
          {
            path: '',
            loadComponent: () => import('app/modules/admin/user-management/user-management.component').then(m => m.UserManagementComponent)
          },
          {
            path: ':employeeCode',
            loadComponent: () => import('app/modules/admin/user-management/components/user-management-detail/user-management-detail.component').then(m => m.UserManagementDetailComponent),
            canDeactivate: [PendingChangesGuard]
          }
        ]
      },

      {
        path: 'system',
        children: [
          {
            path: '',
            loadComponent: () => import('app/modules/admin/system-management/system-management.component').then(m => m.SystemManagementComponent)
          },
          {
            path: ':systemId',
            loadComponent: () => import('app/modules/admin/system-management/components/system-management-detail/system-management-detail.component').then(m => m.SystemManagementDetailComponent),
            canDeactivate: [PendingChangesGuard]
          }
        ]
      },

      {
        path: 'admin/error',
        children: [
          {
            path: '404',
            loadComponent: () => import('app/modules/error/error-404/error-404.component').then(m => m.Error404Component)
          },
          {
            path: '500',
            loadComponent: () => import('app/modules/error/error-500/error-500.component').then(m => m.Error500Component)
          }
        ]
      }
    ]
  },

  {
    path: '**',
    redirectTo: '/error/404'
  }
];
